import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../../app/services/authentication.service';
import { NotificationService } from '../main/shared/notification.service';
import { AuthGuard } from '../../app/authentication/guards/auth-guard.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    message: string;
    routes: any = AuthGuard;
    constructor(private authenticationService: AuthenticationService,
        private notifyService: NotificationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            switch (err.status) {
                case 200: // OK
                    this.message = ("The request is OK.\n" +
                        'Status code: ' + (<HttpErrorResponse>err).status);
                    break;
                case 204: //No Content
                    this.message = ("A status code and a header are given in the response, but there is no entity-body in the reply.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 301: //Move Permanent
                    this.message = ("The requested page has moved to a another url.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 307: //Temporary Redirect
                    this.message = ("The requested page has moved temporarily to a another url.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 308: //Permanent Redirect
                    this.message = ("The requested page has permanent redirect to a another url.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 400: //Bad Request
                    this.message = ("The server did not understand the request.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 401: //Unauthorized
                    this.message = ("Unauthorized request." +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 403: //Forbidden
                    this.message = ("Access is forbidden to the requested page.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 404: //Not found
                    this.message = 'The server can not find the requested page.\n';
                    this.message += '<b>Status code:</b> ' + (<HttpErrorResponse>err).status;
                    break;
                case 405: //method not allowed
                    this.message = 'The 405 method not allowed.\n';
                    this.message += '<b>Status code:</b> ' + (<HttpErrorResponse>err).status;
                    break;
                case 408: //Request time out
                    this.message = ("The request took longer than the server was prepared to wait.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 500: //Internal Server Error
                    this.message = ("The request was not completed. The server met an unexpected condition.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 502: //Bad Gateway
                    this.message = ("The request was not completed. The server received an invalid response from the upstream server.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 503: //Service Unavailable
                    this.message = ("The request was not completed. The server is temporarily overloading or down.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                case 0: //API Server Not Running
                    this.message = ("The request was not completed. May be API server is not running.\n" +
                        '<b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    break;
                default:

                    if (err instanceof HttpErrorResponse) {
                        this.message = (err.message + '\n </b>Status code:</b> ' + (<HttpErrorResponse>err).status);
                    } else if (err instanceof TypeError) {
                        this.message = (err.message);
                    } else if (err instanceof Error) {
                        this.message = (err.message);
                    } else {
                        this.message = ('Nobody throw an error but something happened!.\n' + err);
                    }
                    break;
            }

            if (err.status === 401) {
                // auto logout if 401 response returned from api

                const error = this.message || err.statusText;
           //     this.notifyService.showError(error, 'Error');
              //  //console.log(err);

                this.authenticationService.logout();
                location.reload(true);
               
                
            }
            if (err.error == null) {
                const error = this.message || err.statusText;
              //  this.notifyService.showError(error, 'Error');
             //   //console.log(err);
                return throwError(error);
            }
            if (err.error.isException) {
                const error = this.message || err.statusText;
              //  this.notifyService.showError(error, 'Error');
              //  //console.log(err);
                return throwError(error);
            }
            else if (err.error.message) {
                const error = err.error.message || err.statusText;
               // this.notifyService.showError(error, 'Error');
            //    //console.log(err);
                return throwError(error);
            }
            else {
                const error = this.message || err.statusText;
              //  this.notifyService.showError(error, 'Error');
               // //console.log(err);
                return throwError(error);
            }



        }));
    }
}
